<template>
    <div class="formula-department-container" v-loading="loading">
        <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="'部门选择'"> -->
        <div>
            <div class="tree-wrap">
                <me-tree
                    ref="myTree"
                    :treeData="data"
                    :treeLoading="treeLoading"
                    :treeToolBar="true"
                    :defaultProps="defaultUnitProps"
                    :defaultExpandedKeys="defaultCheckKeys"
                    :nodeKey="'target_unit_id'"
                    :defaultExpandAll="false"
                    :showIcon="true"
                    :showIconKey="'node_expression'"
                    @handleTreeNodeClick="handleTreeNodeClick"
                    @handleAddTreeNode="handleAddTreeNode"
                    @handleEditTreeNode="handleEditTreeNode"
                    @handleDelTreeNode="handleDelTreeNode"
                ></me-tree>
            </div>
        </div>
        <!-- </me-collapes> -->
        <div class="right_container border-left" :style="{ width: '200px' }">
            <div class="point-type">
                <div
                    v-for="item in targetMainData"
                    :key="item + 'i'"
                    :class="
                        curTargetMainId == item.point_class_id
                            ? 'type_orange'
                            : 'type_blue'
                    "
                    @click="changeType(item.point_class_id)"
                >{{ item.class_name }}</div>
            </div>
        </div>
        <div class="leader-tab power-tab right_container border-left" :style="{ width: width }">
            <div class="point-tree">
                <me-tree
                    ref="myPointTree"
                    :treeData="pointData"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :defaultExpandedKeys="defaultPointCheckKeys"
                    :nodeKey="'point_id'"
                    :defaultExpandAll="false"
                    @handleTreeNodeClick="handlePointNodeClick"
                ></me-tree>
            </div>
            <div class="caculate-wrap">
                <div v-for="(item, index) in expressionList" :key="index" class="point_date">
                    <el-radio
                        v-model="curUnitExpressionId"
                        :label="item.unit_expression_id"
                        @change="changeDateRadio()"
                    >{{ "" }}</el-radio>
                    <el-date-picker
                        v-model="item.start_time"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="开始日期"
                    ></el-date-picker>
                    <el-date-picker
                        v-model="item.end_time"
                        type="month"
                        placeholder="结束日期"
                        value-format="yyyy-MM"
                        style="margin-left: 1rem;"
                    ></el-date-picker>
                    <el-button
                        class="leader-common-button"
                        style="margin-left:1rem !important;background-color: #ff6637;border-color: #ff6637;color: #fff"
                        size="small"
                        @click="doAddDate()"
                        v-if="index == expressionList.length - 1"
                    >+</el-button>
                    <el-button
                        class="leader-common-button"
                        style="margin-left:1rem !important;background-color: #ff6637;border-color: #ff6637;color: #fff"
                        size="small"
                        @click="doMinusDate()"
                        v-if="index > 0 && index == expressionList.length - 1"
                    >-</el-button>
                </div>
                <div class="text-wrap">{{ node_expression_show }}</div>
                <div class="express-btn">
                    <div
                        class="express-item"
                        v-for="item in expreeBtns"
                        :key="item + 'i'"
                        @click="clickCaculateBtn(item)"
                    >{{ item }}</div>
                </div>
                <div class="btn-wrap">
                    <div class="btn-inner-wrap">
                        <div class="btn-save" @click="saveTargetExpression">保存</div>
                        <div class="btn-clear" @click="delTargetExpression">清除</div> 
                    </div>
                </div>
            </div>
        </div>
        <unit-dialog
            :dialogVisible.sync="unitVisible"
            :pUnitId="pUnitId"
            :treeUnitId="treeUnitId"
            :unit_id="unit_id"
            :title="title"
            :unitName="unitName"
            @closeCb="closeUnitTree"
        ></unit-dialog>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import * as api from "@/http/api.js";
import {
    getTargetUnitTreeList,
    delTargetUnitTree,
    getTargetExpressionById,
    saveTargetExpression,
    getPointTree
} from "@/http/target-config.js";
import { getPointClassListNew } from "@/http/collection-point-design.js";
import UnitDialog from "./components/unit-dialog.vue";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes,
        "unit-dialog": UnitDialog
    },
    data() {
        return {
            oldUnitExpressionId: "",
            curUnitExpressionId: "",
            unit_id: "",
            data: [],
            pointData: [],
            targetMainData: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            defaultUnitProps: {
                children: "childList",
                label: "target_unit_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            defaultPointCheckKeys: [],
            pointName: "",
            nodeKey: "point_id",
            width: "calc(100% - 370px - 200px)",
            node_expression_show: "",
            node_expression: "",
            point_ids: "",
            expreeBtns: [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                ".",
                "/",
                "(",
                ")",
                "*",
                "+",
                "-"
            ],
            unitVisible: false,
            pUnitId: "",
            treeUnitId: "",
            title: "新增部门",
            unitName: "",
            selectTree: {},
            loading: false,
            curTargetMainId: "",
            unit_expression_id: "",
            expressionList: []
        };
    },
    mounted() {
        this.getTreeUnitList();
    },
    methods: {
        // 获取左侧部门树
        getTreeUnitList() {
            getTargetUnitTreeList().then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    this.defaultCheckKeys = [
                        res.bus_json &&
                        res.bus_json[0] &&
                        res.bus_json[0].target_unit_id
                    ];
                    this.$nextTick(() => {
                        if (this.selectTree.target_unit_id) {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.selectTree.target_unit_id
                            );
                            this.selectTree = this.$refs.myTree.$refs.tree.getCurrentNode();
                        } else {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.defaultCheckKeys[0]
                            );
                            this.selectTree = res.bus_json && res.bus_json[0];
                        }
                        this.unit_id = this.selectTree.unit_id;
                        this.getPointClassList();
                    });
                }
            });
        },
        // 获取指标
        getPointClassList() {
            getPointClassListNew().then(res => {
                if (res && res.error_code === "0") {
                    this.targetMainData = res.bus_json;
                    this.curTargetMainId = this.curTargetMainId
                        ? this.curTargetMainId
                        : this.targetMainData &&
                        this.targetMainData[0] &&
                        this.targetMainData[0].point_class_id;
                    this.getUnitPointList();
                    this.getTargetExpressionById();
                }
            });
        },
        // 新增修改删除部门成功回调
        closeUnitTree() {
            this.pUnitId = "";
            this.treeUnitId = "";
            this.unitName = "";
            this.getTreeUnitList();
        },
        // 添加部门
        handleAddTreeNode(select) {
            if (select.treeLevel == 2) {
                this.$message({
                    message: "子节点下不能再新增节点",
                    type: "warning"
                });
                return;
            }
            this.pUnitId = this.selectTree.target_unit_id;
            this.unit_id = this.selectTree.unit_id;
            this.treeUnitId = "";
            this.title = "新增部门";
            this.unitName = "";
            this.unitVisible = true;
        },
        // 修改部门
        handleEditTreeNode(select) {
            this.pUnitId = this.selectTree.p_target_unit_id;
            this.treeUnitId = this.selectTree.target_unit_id;
            this.unitName = this.selectTree.target_unit_name;
            this.title = "修改部门";
            this.unitVisible = true;
        },
        // 删除部门
        handleDelTreeNode(select) {
            this.pUnitId = this.selectTree.target_unit_id;
            this.$confirm("确定删除此部门?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    delTargetUnitTree({
                        target_unit_id: this.pUnitId
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.selectTree = {};
                            this.closeUnitTree();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        // 点击部门树节点
        handleTreeNodeClick(select) {
            this.selectTree = select;
            this.node_expression_show = "";
            this.node_expression = "";
            this.point_ids = "";
            this.getTargetExpressionById();
            //切换部门树时，重新查询采集点
            this.unit_id = select.unit_id;
            this.getUnitPointList();
        },

        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.w_active == "0") {
                    //0 不让点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else {
                    // 1 让点
                    obj.disabled = false;
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        /**
         * 获取采集点信息
         */
        getUnitPointList() {
            api.getPointTree1({
                elec_customer_id: this.selectTree.elec_customer_id,
                point_class_id: this.curTargetMainId
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.pointData = res.bus_json;
                    let formatData = this.tickMenuIdFilter().filter(
                        res.bus_json
                    );
                    this.defaultPointCheckKeys = [
                        formatData.firstPoint.point_id
                    ];
                }
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes
                ? "calc(100% - 370px - 200px)"
                : "calc(100% - 56px - 200px)";
        },
        // 计算器按钮点击回调
        clickCaculateBtn(caculateBtn) {
            this.node_expression_show += caculateBtn;
            this.node_expression += caculateBtn;
        },
        handlePointNodeClick(select) {
            if (select.w_active == 0) {
                // 0 不让点
                this.$message({
                    message: "此采集点没有w_active采集项",
                    type: "warning"
                });
            } else {
                this.node_expression_show += select.point_name;
                this.node_expression += select.point_id;
                this.point_ids += select.point_id + ",";
            }
        },
        // 清除公式
        delTargetExpression() {
            this.$confirm("确定清除此公式?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.node_expression_show = "";
                    this.node_expression = "";
                    this.point_ids = "";
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        saveTargetExpression() {
            this.loading = true;
            //保存上一次输入的东西
            this.saveLastData();
            const params = {
                target_unit_id: this.selectTree.target_unit_id,
                point_class_id: this.curTargetMainId,
                expressionList: this.expressionList
            };
            saveTargetExpression(params).then(res => {
                if (res && res.error_code == 0) {
                    this.$message({
                        message: res.error_msg,
                        type: "success"
                    });
                    this.node_expression_show = "";
                    this.node_expression = "";
                    this.point_ids = "";
                    this.closeUnitTree();
                }
                this.loading = false;
            });
        },
        getTargetExpressionById() {
            getTargetExpressionById({
                target_unit_id: this.selectTree.target_unit_id,
                point_class_id: this.curTargetMainId
            }).then(res => {
                if (res && res.error_code === "0") {
                    let expressionList = res.bus_json;
                    if (expressionList && expressionList.length) {
                        this.curUnitExpressionId = this.oldUnitExpressionId =
                            expressionList[0].unit_expression_id;
                        this.node_expression_show =
                            expressionList[0].node_expression_show;
                        this.node_expression =
                            expressionList[0].node_expression;
                        this.point_ids = expressionList[0].point_ids;
                    } else {
                        const unit_expression_id = new Date().getTime();
                        expressionList = [];
                        expressionList.push({
                            unit_expression_id: unit_expression_id,
                            start_time: "1999-01",
                            end_time: "2099-01",
                            node_expression: "",
                            point_ids: ""
                        });
                        this.curUnitExpressionId = this.oldUnitExpressionId = unit_expression_id;
                        this.node_expression_show = "";
                        this.node_expression = "";
                        this.point_ids = "";
                    }
                    this.expressionList = expressionList;
                }
            });
        },
        changeType(type) {
            this.curTargetMainId = type;
            this.getUnitPointList();
            this.getTargetExpressionById();
        },
        changeDateRadio() {
            //保存上一次输入的东西
            this.saveLastData();
            //回显
            this.expressionList.forEach(item => {
                if (item.unit_expression_id == this.curUnitExpressionId) {
                    this.node_expression_show = item.node_expression_show || "";
                    this.node_expression = item.node_expression || "";
                    this.point_ids = item.point_ids || "";
                }
            });
        },
        saveLastData() {
            this.expressionList.forEach(item => {
                if (item.unit_expression_id == this.oldUnitExpressionId) {
                    item.node_expression_show = this.node_expression_show;
                    item.node_expression = this.node_expression;
                    item.point_ids = this.point_ids;
                }
            });
            this.oldUnitExpressionId = this.curUnitExpressionId;
        },
        doAddDate() {
            this.expressionList.push({
                unit_expression_id: new Date().getTime(),
                start_time: "",
                end_time: "",
                node_expression: "",
                point_ids: ""
            });
        },
        doMinusDate() {
            this.expressionList.pop();
        }
    }
};
</script>
<style lang="scss">
.formula-department-container {
    width: 100%;
    height: 100%;
    display: flex;
    padding: px2Rem(20px);
    box-sizing: border-box;
    flex-direction: row;
    .tree-container {
        width: px2Rem(280px);
        border-right: 1px solid #b1c7dd;
        overflow-x: hidden;
        padding-right: 20px;
        box-sizing: border-box;
    }
    .active-table {
        background: #ff7455 !important;
        color: #fff !important;
        border-color: #ff7455 !important;
    }
    .tree-wrap {
        height: calc(100% - 10px);
        // padding-top: 2.5rem;
        box-sizing: border-box;
    }
    .right_container {
        height: 100%;
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
        .caculate-wrap {
            width: calc(100% - 300px);
            height: 100%;
            overflow-y: auto;
            .text-wrap {
                width: 100%;
                min-height: 7rem;
                // @include border;
                border-radius: 6px;
                // @include font-color;
                color: #fff;
                font-size: 1.2rem;
                line-height: 1em;
                padding: 0.6rem;
                box-sizing: border-box;
                margin-top: 1rem;
            }
            .express-btn {
                width: 36rem;
                margin-top: 20px;
                display: flex;
                flex-wrap: wrap;
                margin: 0 auto;
                margin-top: 2rem;
                .express-item {
                    margin-right: 1.4rem;
                    margin-bottom: 1.6rem;
                    width: 4rem;
                    height: 4rem;
                    background: linear-gradient(
                        -12deg,
                        #171533,
                        #063b7b,
                        #1e1837
                    );
                    border: 1px solid #56fcff;
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    color: #00e1d4;
                    cursor: pointer;
                }
            }
            .btn-wrap {
                width: 36rem;
                margin: 0 auto;
                margin-top: 1rem;
                .btn-inner-wrap {
                    display: inline-flex;
                    margin-left: 2rem;
                }
                .btn-clear,
                .btn-save {
                    width: 8.5rem;
                    height: 2.2rem;
                    line-height: 2.2rem;
                    text-align: center;
                    font-size: 1rem;
                    color: #fff;
                    border-radius: 0.3rem;
                    cursor: pointer;
                }
                .btn-clear {
                    background: #8e9eab;
                    border: 1px solid #3d3d3d;
                    margin-right: 5rem;
                }
                .btn-save {
                    background: linear-gradient(-12deg, #073775, #5c0991);
                    border: 1px solid #3d3d3d;
                }
            }
            .point_date {
                display: inline-flex;
                align-items: center;
                margin-top: 0.3rem;
                width: 100%;
            }
        }
    }
    .border-left {
        // @include border-left;
    }
    .point-tree {
        height: 100%;
    }
    .point-type {
        height: 100%;
        width: 100%;
        margin: 14px;
        div {
            height: 35px;
            text-align: center;
            line-height: 35px;
            font-size: 14px;
            cursor: pointer;
        }
        .type_orange {
            border-bottom: 1px solid #ff6637;
            color: #ff6637;
        }
        .type_blue {
            // @include border-bottom;
            // @include font-color('color-custom-list');
            color: #fff;
        }
    }
}
</style>
